module.exports = __webpack_public_path__ + "ab6e9c4f684086518515c0fcfa4da0b9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-Axis-webfont.eot
// module id = 93
// module chunks = 0